 import { Head } from 'vite-react-ssg';

function PrivacyPolicy() {
  return (
    <>
      <Head>
        <title>Privacy Policy </title>
        <meta
          name="description"
          content=" How we collect, use, disclose, and safeguard your information when you visit our website, use our services, or communicate with us."
        />
        <link rel="canonical" href="https://apptalyst.com/privacy-policy " />
      </Head>
      <section className="bg-[#f7f9fd] py-20 md:py-32 px-4">
        <div className="container  mt-20">
          <h1
            
            className="  text-2xl md:text-3xl  text-dark pb-5 font-sans"
          >
            Please review how we value and protect your privacy{" "}
          </h1>
          <h2
            
            className="  text-xl md:text-2xl  text-dark pb-5"
          >
            Effective Date: 04/28/2025
          </h2>
          <p className="text-[#616368] text-lg mb-6 ">
            Apptalyst (“Company”, “we”, “our”, or “us”) values your privacy.
            This Privacy Policy explains how we collect, use, disclose, and
            safeguard your information when you visit our website, use our
            services, or communicate with us via SMS or other channels.
          </p>
          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            1. Information We Collect
          </h2>
          <p className="text-[#616368] text-lg mb-6 ">
            We may collect personal information you voluntarily provide to us,
            including your name, email address, phone number, and any other
            details you submit through our website, contact forms or
            communications.
          </p>
          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            2. How We Use Your Information
          </h2>
          <p className="text-[#616368] text-lg  mb-4 ">
            We may use the information we collect to:{" "}
          </p>

          <ul className="text-[#616368] text-lg space-y-2  list-disc list-inside mb-6 pl-2 md:pl-6 ">
            <li>Respond to your inquiries or service requests.</li>
            <li>
              Send occasional prol communications, including SMS
              messages, if you have consented.
            </li>
            <li>Provide updates related to your projects or service status.</li>
            <li>
              Send meeting invitations, quotes, samples, or requested
              references.
            </li>
            <li>Improve our services, website, and customer experiences.</li>
          </ul>
          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            3. SMS Communications
          </h2>
          <p className="text-[#616368] text-lg mb-4 ">
            By providing your phone number and opting in via our forms or during
            verbal conversations, you consent to receive SMS messages from
            Apptalyst. These may include project updates, reminders, prol
            offers, meeting invites, or other service-related content.
          </p>
          <ul className="text-[#616368] text-lg space-y-2  list-disc list-inside mb-6 pl-2 md:pl-6">
            <li>Message frequency may vary.</li>
            <li>Message and data rates may apply.</li>
            <li>You can opt out anytime by replying "STOP".</li>
            <li>
              For help, reply "HELP" or email us at{" "}
            <span className="underline decoration-[#6D1349] text-[#6D1349]">
                {" "}
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=support@apptalyst.com&su=Subject&body=Message"
                  target="_blank"
                >
                  support@apptalyst.com
                </a>
              </span>
              .
            </li>
            <li>We do not send unsolicited messages.</li>
          </ul>
          <p className="text-[#616368] text-lg mb-6 ">
            <span className="font-bold">Sender Identification: </span> All
            messages will clearly identify “Apptalyst” as the sender.
          </p>
          <p className="text-[#616368] text-lg mb-6 ">
            <span className="font-bold">Data Retention for SMS Consent: </span>
            We retain records of opt-in consent (timestamp, source, campaign,
            and number) as required by law and industry standards.
          </p>

          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            4. Data Security
          </h2>
          <p className="text-[#616368] text-lg mb-6 ">
            We implement appropriate and reasonable administrative, technical,
            and physical security measures to protect your personal data from
            unauthorized access, alteration, or disclosure. However, no method
            of transmission over the Internet is 100% secure.
          </p>

          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            5. Sharing of Information
          </h2>
          <p className="text-[#616368] text-lg mb-4 ">
            We do not sell, trade, or rent your personal information. No mobile
            information will be shared with third parties/affiliates for
            marketing/prol purposes. All other categories exclude text
            messaging originator opt-in data and consent; this information will
            not be shared with any third parties.
          </p>
          <p className="text-[#616368] text-lg mb-4 ">
            We may share data only when required to:
          </p>
          <ul className="text-[#616368] text-lg space-y-2  list-disc list-inside mb-6 pl-2 md:pl-6">
            <li>Comply with applicable laws or legal processes.</li>
            <li>Protect our legal rights or enforce our Terms of Service.</li>
          </ul>

          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            6. Your Rights
          </h2>
          <p className="text-[#616368] text-lg mb-6 ">
            You may request to review, update, or delete your personal
            information. You may also withdraw your consent for communications
            by emailing us at{" "}
            <span className="underline decoration-[#6D1349] text-[#6D1349]">
              {" "}
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=support@apptalyst.com&su=Subject&body=Message"
                target="_blank"
              >
                support@apptalyst.com
              </a>
            </span>
            .
          </p>
          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            7. Website Forms and Consent
          </h2>
          <p className="text-[#616368] text-lg mb-6 ">
            Our forms include clear consent language and unchecked checkboxes
            that you must actively select to receive SMS or email
            communications. These forms disclose message rates, frequency, and
            opt-out options.
          </p>
          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            8. External Links
          </h2>
          <p className="text-[#616368] text-lg mb-6 ">
            Our website may include links to third-party websites. We are not
            responsible for the content or privacy practices of those external
            sites.
          </p>
          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            9. Governing Law
          </h2>
          <p className="text-[#616368] text-lg mb-6 ">
            This Privacy Policy is governed by the laws of the Commonwealth of
            Virginia, United States, where Apptalyst is registered.
          </p>

          <h2
            
            className="  text-2xl md:text-3xl text-dark font-bold pb-5"
          >
            10. Contact Us
          </h2>
          <p className="text-[#616368] text-lg  ">
            If you have questions about this Privacy Policy, please contact us
            at:{" "}
            <span className="underline decoration-[#6D1349] text-[#6D1349]">
              {" "}
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=support@apptalyst.com&su=Subject&body=Message"
                target="_blank"
              >
                support@apptalyst.com
              </a>
            </span>
          </p>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
